import * as R from 'ramda';
import { FilterBuilder } from '../Types';
import { MaxBedroomCount } from '../constants';

const roomsBuilder: FilterBuilder = params => {
  const bedroomCount = (params.rooms && params.rooms.bedroomCount) || 0;

  if (!bedroomCount) {
    return '';
  }

  // facility_bedroom_count is not a number attribute, so we need to get all possibilities
  return R.range(bedroomCount, MaxBedroomCount + 1)
    .map(
      count =>
        `facility_bedroom_count:${count}${
          count === MaxBedroomCount ? '+' : ''
        }`,
    )
    .join(' OR ');
};
export default roomsBuilder;
